import { MountNotifier } from "@/components/common/mount-notifier";
import { setModeIsLoadingData } from "@/store/mode-slice";
import { useAppDispatch } from "@/store/store-hooks";
import { PropsWithChildren, Suspense, useCallback, type JSX } from "react";
import { SnapshotRenderer } from "../renderers/snapshot-renderer";

type SuspenseLoadNotifierProps = PropsWithChildren & {
  /** Whether a snapshot renderer should be instanced or not */
  withSnapshotRenderer?: boolean;
};

/**
 * @returns A react suspense that will render the last valid scene and notify the app that data is loading
 */
export function SuspenseLoadNotifier({
  children,
  withSnapshotRenderer = true,
}: SuspenseLoadNotifierProps): JSX.Element {
  const dispatch = useAppDispatch();
  const onMountChanged = useCallback(
    (isLoading: boolean) => {
      dispatch(setModeIsLoadingData(isLoading));
    },
    [dispatch],
  );

  return (
    <Suspense
      fallback={
        <MountNotifier onMountChanged={onMountChanged}>
          {withSnapshotRenderer && <SnapshotRenderer />}
        </MountNotifier>
      }
    >
      {children}
    </Suspense>
  );
}
